import Modal from './Modal';

export default function ConfirmModal({
    open,
    title = 'Подтверждение',
    message,
    confirmLabel = 'Подтвердить',
    cancelLabel = 'Отмена',
    danger = false,
    loading = false,
    onConfirm,
    onClose,
}) {
    return (
        <Modal
            open={open}
            title={title}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn--outline btn--sm" onClick={onClose} disabled={loading}>
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`btn btn--sm${danger ? ' btn--danger' : ' btn--primary'}`}
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Подождите...' : confirmLabel}
                    </button>
                </>
            )}
        >
            <p className="confirm-modal__text">{message}</p>
        </Modal>
    );
}
